import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, ViewChildren, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { LoginModel, AppUserAuth } from 'src/app/Models/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { AuthService } from 'src/app/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { ILicenseStatus } from 'src/app/shared/models/license/license-status.model';
import { ToastrService } from 'ngx-toastr';
import { LicenseService } from 'src/app/shared/services/license.service';
import { ILicense } from 'src/app/shared/models/license/license.model';
import { GlobalFunction } from 'src/app/shared/global-function';

import * as $ from 'jquery';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})


export class LoginComponent implements OnInit, AfterViewInit, OnDestroy
{
    private subscriptions: Subscription[] = [];
    public isLoading: boolean;
    public settings: Settings;

    translationObject: any

    public license: ILicense;
    licenseStatus: number;
    private licenseDaysShowBeforeExpired = 30;
    loginError: boolean = false;
    securityObject: AppUserAuth = null;
    loginValid: boolean = false;

    @ViewChildren('input') vc;
    @ViewChild("name", { static: true }) nameField: ElementRef;

    user: LoginModel;
    loginErrorMessage: string;
    hideErrorMessage: boolean = true;
    loginForm: UntypedFormGroup;
    hidePassword: boolean = true;

    constructor(
        public appSettings: AppSettings,
        private router: Router,
        private fb: UntypedFormBuilder,
        private authService: AuthService,
        private snackBar: MatSnackBar,
        public toasterService: ToastrService,
        private translateService: TranslateService,
        private appConfigService: AppConfigService,
        private licenseService: LicenseService
    )
    {
        this.user = new LoginModel();
        this.settings = this.appSettings.settings;
    }

    ngOnInit()
    {
        this.loginForm = this.fb.group({
            // use other min length later.
            'IsADUser': [{ value: false}],
            'Name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
            'Password': ['', Validators.compose([Validators.required, Validators.minLength(3)])]
        });

          

        //todo: cleanup if all works
        this.subscriptions.push(this.licenseService.getLicense().subscribe(
            {
                next: (license: ILicense) => 
                {
                    this.license = license
                    this.authService.licenses = license;
                }
            }
        ));

        this.subscriptions.push(this.translateService.get(['General.Application.Messages.LISENSE.IS_SOON_EXPIRED', 'General.Application.Messages.LISENSE.IS_EXPIRED', 'General.Application.Messages.LISENSE.IS_MISSING', 'UI.Buttons.Close']).subscribe((translation: [string]) =>
        {
            this.translationObject = translation;
        }));


        this.loginForm.patchValue({
            IsADUser: this.user?.IsADUser ?? false
        });
        this.onChange();
        
    }

    onChange(): void
    {

        // delete the error message.
        this.subscriptions.push(this.loginForm.controls['Name'].valueChanges.subscribe(_ =>
        {
            this.loginError = false;
        }
        ));

        this.subscriptions.push(this.loginForm.controls['Password'].valueChanges.subscribe(_ =>
        {
            this.loginError = false;
        }
        ));
    }

    ngAfterViewInit()
    {
        this.settings.loadingSpinner = false;
        $(document).ready(function ()
        {
            $('.material-icons').css('opacity', '1');
        });
    }


    login()
    {
        if (!this.loginForm.valid)
        {
            return;
        }

        this.isLoading = true;

        const data = { ...this.user, ...this.loginForm.value };

        this.subscriptions.push(this.authService.login(data)
            .subscribe(
                {
                    next: (validLogin: boolean) =>
                    {
                        this.isLoading = false;
                        this.loginValid = validLogin;
                        this.loginError = !this.loginValid

                        if (this.authService.licenseStatus === ILicenseStatus.IsExpired)
                        {
                            // not closable anymore.
                            let message = this.translationObject['General.Application.Messages.LISENSE.IS_EXPIRED'];
                            message = this.appConfigService.formatLocalDate(message, this.authService.licenseExpiryDate);
                            this.toasterService.error(message);
                        }
                        else if (this.authService.licenseStatus === ILicenseStatus.WillExpire)
                        {
                            let message = this.translationObject['General.Application.Messages.LISENSE.IS_SOON_EXPIRED'];
                            message = this.appConfigService.formatLocalDate(message, this.authService.licenseExpiryDate);
                            this.toasterService.error(message);
                        }

                    },

                    error: (error: any) =>
                    {
                        this.isLoading = false;
                        this.loginError = true;
                        if (!GlobalFunction.isEmpty(this.nameField))
                        {
                            this.nameField.nativeElement.focus();
                        }
                    },

                    complete: () => 
                    {
                        if (!this.loginValid)
                        {
                            this.isLoading = false;
                            this.loginError = true;
                            if (!GlobalFunction.isEmpty(this.nameField))
                            {
                                this.nameField.nativeElement.focus();
                            }
                        }
                    }
                }
            ));
    }

    logout()
    {
        this.authService.logout();
    }

    onSubmit()
    {
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    toggleHidePassword()
    {
        this.hidePassword = !this.hidePassword;
    }
}

